export default "/static/build/our-mission-mobile.webp";